import React from 'react';

const SvgTripPreview = ({ svgRef, title, ...props }) => (
  <svg width="12px" viewBox="0 0 8 26" version="1.1" ref={svgRef} {...props}>
    <title>{title}</title>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Icon">
        <circle id="Oval" stroke="#35D1CA" strokeWidth="2" cx="4" cy="4" r="3"></circle>
        <circle id="Oval-Copy" stroke="#1A6968" strokeWidth="2" cx="4" cy="22" r="3"></circle>
        <rect id="Rectangle" fill="#6F8089" x="3" y="9" width="2" height="2"></rect>
        <rect id="Rectangle-Copy" fill="#6F8089" x="3" y="12" width="2" height="2"></rect>
        <rect id="Rectangle-Copy-2" fill="#6F8089" x="3" y="15" width="2" height="2"></rect>
      </g>
    </g>
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgTripPreview svgRef={ref} {...props} />);
export default ForwardRef;



// WEBPACK FOOTER //
// ./src/common/icons/TripPreview.js